export const CircularProgress = ({
	progress,
	size,
	className,
	background = 'lightgray',
	strokeColor = 'black'
}: {
	progress: number
	size: number
	className?: string
	background?: string
	strokeColor?: string
}) => {
	const radius = size / 2
	const stroke = radius * 0.25
	const normalizedRadius = radius - stroke * 0.5
	const circumference = normalizedRadius * 2 * Math.PI

	const strokeDashoffset = circumference - (progress / 100) * circumference

	return (
		<svg
			aria-hidden='true'
			className={className}
			height={radius * 2}
			width={radius * 2}
		>
			<circle
				cx={radius}
				cy={radius}
				fill='transparent'
				r={normalizedRadius}
				stroke={background}
				strokeWidth={stroke}
			/>
			<circle
				cx={radius}
				cy={radius}
				fill='transparent'
				r={normalizedRadius}
				stroke={strokeColor}
				strokeDasharray={`${circumference} ${circumference}`}
				strokeDashoffset={strokeDashoffset}
				strokeLinecap='round'
				strokeWidth={stroke}
				style={{
					transition: 'stroke-dashoffset 0.35s',
					transform: 'rotate(-90deg)',
					transformOrigin: '50% 50%'
				}}
			/>
		</svg>
	)
}

CircularProgress.displayName = 'CircularProgress'
